import type { FeedMessage, FeedRow } from "@/types";
import { dateKey, formatDateLabel } from "@/utils/format";

export function buildFeedRows(messages: FeedMessage[]): FeedRow[] {
  const out: FeedRow[] = [];
  let lastDate = "";

  for (const msg of messages) {
    const dk = dateKey(msg.date);
    if (dk !== lastDate) {
      lastDate = dk;
      out.push({
        kind: "date",
        key: `date-${dk}`,
        label: formatDateLabel(msg.date),
      });
    }
    out.push({ kind: "message", key: `msg-${msg.id}`, message: msg });
  }

  return out;
}

export function mergeById(
  archive: Map<string, FeedMessage>,
  live: FeedMessage[]
): Map<string, FeedMessage> {
  const map = new Map(archive);
  for (const msg of live) {
    map.set(String(msg.id), msg);
  }
  return map;
}
